import { ReactElement, useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/logo.png'
import { useClickOutside } from '../../hooks/useClickOutside'
import * as S from './styled'

export default function Header (): ReactElement {
  const [menuOpen, setMenuOpen] = useState(false)
  const [wrapperRef] = useClickOutside(() => setMenuOpen(false))

  const toggleMenu = (): void => setMenuOpen(!menuOpen)

  return <S.Container ref={wrapperRef}>
    <Link to="/">
      <figure>
        <img src={logo} alt="Logo Cartão de Todos" />
      </figure>
    </Link>

    <S.DesktopContent>
      <S.NavList>
        <ul>
          <li>
            <a href="/#beneficios" target="_self">
              Benefícios
            </a>
          </li>

          <li>
            <a href="/#como-funciona">
              Como funciona
            </a>
          </li>

          <li>
            <a href="/#quem-somos">
              Quem somos
            </a>
          </li>

          <li>
            <a href="/#clinicas">
              Clínicas
            </a>
          </li>

          <li>
            <a href="/#faq">
              FAQ
            </a>
          </li>
      </ul>
      </S.NavList>

      <a href="/#fale-conosco" target="_self">
        <button>Fale conosco</button>
      </a>
    </S.DesktopContent>

    <S.MobileContent>
      <S.MobileMenuToggle className={menuOpen ? 'open' : ''} onClick={toggleMenu}>
        <div />
        <div />
        <div />
      </S.MobileMenuToggle>

      <S.MobileMenuContainer $menuOpen={menuOpen}>
        <S.MobileMenuContent>
          <S.NavList>
            <ul>
              <li>
                <a onClick={toggleMenu} href="/#beneficios" target="_self">
                  Benefícios
                </a>
              </li>

              <li>
                <a onClick={toggleMenu} href="/#como-funciona">
                  Como funciona
                </a>
              </li>

              <li>
                <a onClick={toggleMenu} href="/#quem-somos">
                  Quem somos
                </a>
              </li>

              <li>
                <a onClick={toggleMenu} href="/#clinicas">
                  Clínicas
                </a>
              </li>

              <li>
                <a onClick={toggleMenu} href="/#faq">
                  FAQ
                </a>
              </li>
            </ul>
          </S.NavList>
        </S.MobileMenuContent>
      </S.MobileMenuContainer>
    </S.MobileContent>
  </S.Container>
}
